import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, withRouter } from 'react-router';
import { ReviewContextType, ReviewType } from '../../../propTypes';
import { faPencil } from '@fortawesome/pro-solid-svg-icons/faPencil';
import { present } from '../../../utils/strings';
import { reviews } from 'ducks';

/**
 * Shows a list of review comments with links to their pages.
 *
 * @param review the review object
 * @param reviewContext the review context
 * @return {JSX.Element}
 */
const ReviewComments = ({ review, reviewContext }) => {
  const { paginator } = reviewContext;
  const { currPage, pages } = paginator;

  // avoid showing the summary comment on the summary page
  const showSummary = !currPage.commentRef || currPage.commentRef.field !== 'scores_comment';

  return (<React.Fragment>
    {pages
      .filter(page => page.commentRef && (showSummary || page.commentRef.field !== 'scores_comment'))
      .map((page, i) => {
        const value = reviews.getComment(review, page.commentRef);

        return <div key={i} className="review-cover-sheet-item">
          <div className="row">
            <div className="col-5">
              <div className="review-cover-sheet-item-name">{page.name}</div>
            </div>
            <div className="col-19">
              {present(value) && <div className="review-cover-sheet-item-comment">
                {value}

                {review.editable &&
                  <React.Fragment>
                    {' '}<Link to={page.href}><FontAwesomeIcon icon={faPencil}/></Link>
                  </React.Fragment>}
              </div>}

              {review.editable && !present(value) && <div className="review-cover-sheet-item-comment-empty">
                Review the <Link to={page.href}>{page.name}</Link> page to add comments.
              </div>}
            </div>
          </div>
        </div>;
      })}
  </React.Fragment>);
};

ReviewComments.propTypes = {
  review: ReviewType.isRequired,
  reviewContext: ReviewContextType.isRequired,
};

export default withRouter(ReviewComments);
